window.dataLayer = window.dataLayer || [];
/**
 * Google tag API.
 *
 * @see https://developers.google.com/tag-platform/gtagjs/reference
 */
export function gtag() {
  window.dataLayer.push(arguments);
}
